import React from 'react';


const InfoVideo = () => {
    return(
      <div style={{ zIndex: 100, backgroundColor: 'black', height: '100%', width: '100%', position: 'fixed', top: 0 }}>
        <video  allowfullscreen autoPlay="autoPlay" controls autoplay="autoplay" muted height="100%" width="100%"> 
            <source  type="video/mp4" src={'https://briiskidev.blob.core.windows.net/surething/iTOO-SureThing-Explainer-Video.mp4'}></source>
        </video>
      </div>
    )
}

export default InfoVideo;